require("jquery-formatcurrency");
require("jquery-ui/ui/widgets/slider");
require("../vendor/jquery.ui.touch-punch.min.js")

var container = $('#sba-loan-calculator'),
    $typeRadio = container.find('.loan-type-radio'),
    $interest = container.find('#interest'),
    $sliderEl = container.find('#slider'),
    $loanAmtEl = container.find('#loanAmt'),
    $termEl = container.find('#term'),
    $minEl = container.find('.loan-min'),
    $maxEl = container.find('.loan-max');

$sliderEl.slider({
    range: 'min',
    min: 100000,
    max: 1000000,
    value: 450000,
    step: 1000,
    create: function(event, ui) {
        var v=$(this).slider('value'),
            opts = $(this).slider('option');

        $loanAmtEl.css('left', $(this).find('.ui-slider-handle').css('left'));
        $loanAmtEl.val(v).formatCurrencyLive({ roundToDecimalPlace: 0 });
        $minEl.text(opts.min).formatCurrency({ roundToDecimalPlace: 0 });
        $maxEl.text(opts.max).formatCurrency({ roundToDecimalPlace: 0 });
        termCalc(v);
    },
    slide: function( event, ui ) {
        $loanAmtEl.val(ui.value).formatCurrencyLive({ roundToDecimalPlace: 0 });
        $loanAmtEl.css('left', $(this).find('.ui-slider-handle').css('left'));
        termCalc(ui.value);
    },
    change: function(event, ui) {
        $loanAmtEl.css('left', $(this).find('.ui-slider-handle').css('left'));
        termCalc(ui.value);
    }
});

$sliderEl.on('input change',function(){
    $loanAmtEl.val($(this).val());
});

$termEl.on('change', function(){
    var fieldID = container.parents('.gform_wrapper').find("label:contains('Selected Loan Term')").attr('for');
    $('#'+fieldID).val($(this).val()).change();
    termCalc($sliderEl.slider('option','value'));
});

$loanAmtEl.keyup(function(e){
    var val = $(this).val().replace(/\D/g,'');   // check only for digits
    $sliderEl.slider('option','value', val)
});

$typeRadio.on('click', function(e) {
    if($(this).attr('id') == 'loanCapital') {
        type = 'capital';
    } else {
        type = 'realEstate'
    }

    $.post('/wp-admin/admin-ajax.php', {
        action: "SBALoanType",
        type: type,
    }).done(function(r) {
        // console.log(r)
        if (r.success) {
            var rate = r.data.rate,
                disclosure = r.data.disclosure,
                fieldID = container.parents('.gform_wrapper').find("label:contains('Loan Type')").attr('for');


            $interest.attr('data-rate', rate);
            $interest.text(rate + "%");

            container.find('.disclosure-text').html(disclosure);

            
            if(type == 'realEstate') {
                min = 500000;
                max = 2500000;
                val = 1500000;
                $('#'+fieldID).val('Real Estate').change();
                $termEl.attr('max',20);
            } else {
                min = 100000;
                max = 1000000;
                val = 450000;
                $('#'+fieldID).val('Capital').change();
                $termEl.attr('max',10);
                $termEl.val(10);
            }
            $sliderEl.slider('option', {
                min: min,
                max: max,
                value: val,
            });

            $loanAmtEl.css('left', container.find('.ui-slider-handle').css('left'));
            $loanAmtEl.val(val).formatCurrencyLive({ roundToDecimalPlace: 0 });
            $minEl.text(min).formatCurrency({ roundToDecimalPlace: 0 });
            $maxEl.text(max).formatCurrency({ roundToDecimalPlace: 0 });
        } else {
            
        }
    });
});


function termCalc(principal) {
    var interest = $interest.attr('data-rate'),
        term = $termEl.val(),
        calculatedInterest = interest / 100 / 12,
        calculatedPayments = 12*term, // term years * 12 months per year
        LoanAmtFieldID = container.parents('.gform_wrapper').find("label:contains('Loan Amount')").attr('for');
        
    $('#'+LoanAmtFieldID).val(principal).change();

    var x = Math.pow(1 + calculatedInterest, calculatedPayments);
    var monthly = (principal * x * calculatedInterest) / (x - 1);

    if(isFinite(monthly)) {
        $('#monthly').text(monthly).formatCurrency({ roundToDecimalPlace: 0 });
        var APR = calcInterest(principal, (principal*(interest/100)*term), term);
        $('#apr').text(parseFloat(APR).toFixed(2)+"%");
    }
}

function calcInterest(loanAmt, interest, term) {
    var SBAfees = 0;
    if(loanAmt <= 150000) {
        // SBAfees = loanAmt * .017;
    } else {
        // SBAfees = loanAmt * .0225;
    }
    var fees = SBAfees + 2500;
    var totalDays = term*365 // term years * 365 days per year

    return ((fees + interest) / loanAmt) / totalDays * 365 * 100;
}